import React from 'react';
import { Checkbox } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import { CypressIds } from '../../../../../../../../../../../../../../../constants/cypressIds';

const CheckboxCell = ({ value, linkedPolicyIds, handlePolicyIdChange }) => (
  <Checkbox
    borderColor="greyScale.300"
    data-cy={CypressIds.linkedPolicyDocCheckBox(value)}
    isChecked={linkedPolicyIds?.includes(value)}
    mb={0}
    value={value}
    onChange={e => {
      handlePolicyIdChange({ policyId: value, isChecked: e.target.checked });
    }}
  />
);

CheckboxCell.propTypes = {
  document: PropTypes.shape({ policies: PropTypes.arrayOf(PropTypes.shape({})) }),
  value: PropTypes.number,
  linkedPolicyIds: PropTypes.object.isRequired,
  handlePolicyIdChange: PropTypes.func.isRequired
};

export default CheckboxCell;
